<h2
	class="default-dialog-header"
	mat-dialog-title
	class="default-dialog-header m-b-1"
	fxLayoutAlign="space-between center"
>
	<span>Automatically Notify Procured Carriers</span>
	<span fxLayoutAlign="end center">
		<mat-icon (click)="closeDialog(null)" class="primary-light-color cursor-pointer"
			>close</mat-icon
		>
	</span>
</h2>
<mat-divider></mat-divider>

<mat-dialog-content class="default-dialog-content font-size-12 m-t-4 p-b-1">
	<form
		(keydown.enter)="$event.preventDefault()"
		[formGroup]="notifyProcuredCarriersForm"
		class="full-width"
	>
		<div class="full-width">
			<mat-radio-group formControlName="notifyProcuredCarriers" fxLayout="row" class="full-width">
				<div fxFlex fxLayoutAlign="center center">
					<mat-radio-button class="font-size-12 m-t-1" color="primary" [value]="true">
						Yes
					</mat-radio-button>
				</div>
				<div fxFlex fxLayoutAlign="center center">
					<mat-radio-button class="font-size-12 m-t-1" color="primary" [value]="false">
						No
					</mat-radio-button>
				</div>
			</mat-radio-group>
		</div>
	</form>
</mat-dialog-content>

<mat-divider></mat-divider>

<mat-dialog-actions class="default-dialog-action" fxLayoutGap="1rem">
	<div fxFlex fxLayoutAlign="end center" fxLayoutGap="1rem">
		<span (click)="closeDialog(null)" class="link">Cancel</span>
		<button
			(click)="createProject()"
			[disabled]="notifyProcuredCarriersForm.invalid"
			color="primary"
			mat-raised-button
		>
			Next
		</button>
	</div>
</mat-dialog-actions>
